module.exports = __webpack_public_path__ + "svg/icon-arrow-right.svg";